import { BrokenTeethIcon, SuccessIcon } from "../../Icons/Icons";

const SystemMsg = (props: {
  messageType?: "success" | "error";
  message?: string;
}) => {
  const { message = "Oops, something went wrong...", messageType = "error" } =
    props;

  return (
    <div className="msg-wrapper">
      <div className="row icon">
        {messageType === "error" ? <BrokenTeethIcon /> : <SuccessIcon />}
      </div>
      <div className="row">
        <h2>{message}</h2>
      </div>
    </div>
  );
};

export default SystemMsg;
